import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserAuth } from '../../contexts/UserAuthContext';
import LoadingSpinner from '../common/LoadingSpinner';
import { apiService } from '../../services/api';

interface AuthRedirectProps {
  children: React.ReactNode;
}

const AuthRedirect: React.FC<AuthRedirectProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useUserAuth();
  const location = useLocation();
  const [redirectLoading, setRedirectLoading] = useState(false);
  const [redirectTo, setRedirectTo] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated && !redirectLoading && !redirectTo) {
      // Check if user has requests to determine where to redirect
      const checkUserRequests = async () => {
        setRedirectLoading(true);
        try {
          const requestsResponse = await apiService.getUserRequests();
          const hasRequests = requestsResponse.requests && requestsResponse.requests.length > 0;

          // If user came from a specific page, honor that redirect
          if (location.state?.from?.pathname) {
            setRedirectTo(location.state.from.pathname);
          } else {
            // For authenticated users without a specific target, redirect based on whether they have requests
            const destination = hasRequests ? '/dashboard' : '/dashboard/requests';
            setRedirectTo(destination);
          }
        } catch (error) {
          // If we can't fetch requests, default to dashboard          const from = location.state?.from?.pathname || '/dashboard';
          setRedirectTo(from);
        } finally {
          setRedirectLoading(false);
        }
      };

      checkUserRequests();
    }
  }, [isAuthenticated, location.state, redirectLoading, redirectTo]);

  if (isLoading || (isAuthenticated && redirectLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (isAuthenticated && redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default AuthRedirect;